import React from 'react';
import Icon, { WarningFilled, ExclamationCircleFilled } from '@ant-design/icons';

import { colors } from 'helpers/ColorHelper';

const priorityIconColors = {
  Emergency: colors.YUHU_RED,
  High: colors.YELLOW_ORANGE,
  Normal: colors.BLUEY_GREY,
};

export default ({ priority, ...rest }) => {
  return (
    <Icon
      style={{ color: priorityIconColors[priority] }}
      component={['High', 'Emergency'].includes(priority) ? WarningFilled : ExclamationCircleFilled}
      theme="filled"
      {...rest}
    />
  );
};
